
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"clientFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"client"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client_live_with_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientLiveWith"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gender_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"is_homeschooled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"homeschooledLabel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"initial_evaluation_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_evaluation_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showUpcomingEvaluationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"family"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"chapter"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"evaluator"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zoom_link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zoom_meeting_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"zoom_passcode"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"canCreateReEvaluation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasDraftReEvaluation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasActiveProgram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasEvaluations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pageSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"clientPageSettingsFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"upcomingEvaluation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"clientUpcomingEvaluationFields"},"directives":[]}]}}]}}],"loc":{"start":0,"end":860}};
    doc.loc.source = {"body":"#import \"@/graphql/fragments/client-page-settings/clientPageSettingsFields.gql\"\n#import \"@/graphql/fragments/client/clientUpcomingEvaluationFields.gql\"\n\nfragment clientFields on client {\n  id\n  first_name\n  last_name\n  full_name\n  date_of_birth\n  age\n  photo\n  client_live_with_id\n  clientLiveWith {\n    name\n  }\n  gender_id\n  gender {\n    name\n  }\n  is_homeschooled\n  homeschooledLabel\n  initial_evaluation_date\n  last_evaluation_date\n  showUpcomingEvaluationDate\n  family {\n    full_name\n    chapter {\n      name\n    }\n  }\n  coach {\n    full_name\n    email\n  }\n  evaluator {\n    full_name\n    email\n    zoom_link\n    zoom_meeting_id\n    zoom_passcode\n  }\n  canCreateReEvaluation\n  hasDraftReEvaluation\n  hasActiveProgram\n  hasEvaluations\n  pageSettings {\n    ...clientPageSettingsFields\n  }\n  upcomingEvaluation {\n    ...clientUpcomingEvaluationFields\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/client-page-settings/clientPageSettingsFields.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@/graphql/fragments/client/clientUpcomingEvaluationFields.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["clientFields"] = oneQuery(doc, "clientFields");
        
